import _ from 'lodash';

export default ({
  field, list, operator, valueIsString,
}) => list && !_.isEmpty(list) && list.map((item) => ({
  field,
  value: valueIsString ? item : item.value,
  operator,
}));
